import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: UpdateTaskInput!) {
    updateTask (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/BacklogTasks/UpdateMutation.js